// Add your custom JS here.
document.addEventListener('DOMContentLoaded', function() {
    const nav = document.querySelector('#main-nav');
    
    window.addEventListener('scroll', function() {
        if (window.scrollY > 20) {
            nav.classList.add('navbar-scrolled');
        } else {
            nav.classList.remove('navbar-scrolled');
        }
    });
});